import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d3ssphc04o: FaireBrandEntity = {
  token: "b_d3ssphc04o",
  type: "brand",
  name: "Planet Bake",
  avatarUrl:
    "https://cdn.faire.com/fastly/0df30cd8d26092a7bed80874f39d1b509c0d5c7143b899a9d37e2c8d9b80a938.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/45c0b386f88aca7fd9502400fdae86b5ce11032acaa360a95d3104184e9fac95.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0df30cd8d26092a7bed80874f39d1b509c0d5c7143b899a9d37e2c8d9b80a938.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/45c0b386f88aca7fd9502400fdae86b5ce11032acaa360a95d3104184e9fac95.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 39,
  rating: 4.7,
  reviewCount: 16,
  isInsider: true,
  description:
    "Born out of the pandemic, Planet Bake was created to fill a clear gap: there were no clean, sugar-free, plant-based treats on the market. \n\nTraditional fried donuts deliver nostalgia but provide no nutritional value. With an American father, donuts were part of my childhood, but I saw the urgent need to reinvent them, especially as diabetes, chronic illness, and even colon cancer runs in my family.  \n\nPlanet Bake transforms indulgence into wellness, turning a beloved classic into a nutritious, sugar-free donut for today’s health-conscious consumer.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:22.527Z",
    importedBy: "entity-db-cli",
  },
};
